enum LabelTypes {
    DEFAULT = 'default',
    DEFAULT_SMALL = 'default--small',
    SUCCESS = 'success',
    SUCCESS_SMALL = 'success--small',
    ATTENTION = 'attention',
    ATTENTION_SMALL = 'attention--small',
    INFO = 'info',
    INFO_SMALL = 'info--small',
    ERROR = 'error',
    ERROR_SMALL = 'error--small',
    WARNING = 'warning',
    WARNING_SMALL = 'warning--small',
    EXTERNAL_LINK = 'external-link',
    INVERTED = 'inverted',
    INVERTED_SMALL = 'inverted--small',
}

export default LabelTypes;
